import axios from 'axios';

export default {
  fetchEmailCustomContent(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/email-custom-contents",{params})
      .then(results=>{
        return results.data;
      })
  },
  delete(id){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/email-custom-contents/"+id)
      .then(results=>{
        return results.data;
      })
  },
  fetchTypes(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/email-custom-contents/types")
      .then(results=>{
        return results.data;
      })
  },
  post(ecc){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/email-custom-contents", ecc)
      .then(results=>{
        return results.data;
      })
  },
  put(ecc){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/email-custom-contents/"+ecc.id, ecc)
      .then(results=>{
        return results.data;
      })
  }
}
